<template>
  <div class="new-company-calculator" style="width: 100vw">
    <div class="column">
      <div
        class="column is-four-fifths"
        style="padding: 0; paddingbottom: 1.5rem"
      >
        <b-field :label="$t('時間')">
          <b-select v-model="interval" rounded>
            <option
              v-for="option in intervalChoices"
              :key="option.type"
              :value="option.type"
            >
              {{ $t(option.optionName) }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="control" style="paddingbottom: 1rem">
        <b-radio v-model="ageType" name="name" native-value="lessAge">
          {{ $t("65歲以下") }}
        </b-radio>
        <b-radio v-model="ageType" name="name" native-value="equalAge">
          {{ $t("2021年度剛滿65歲") }}
        </b-radio>
        <b-radio v-model="ageType" name="name" native-value="greaterAge">
          {{ $t("65歲以上/殘疾人士") }}
        </b-radio>
      </div>

      <b-field
        v-if="ageType == 'equalAge'"
        :label="$t('出生年份')"
        :message="$t(validation.firstError('birthYear'))"
      >
        <b-input v-model="birthYear"></b-input>
      </b-field>

      <b-field
        :label="$t('A.' + getInterval(interval) + '總收益（包括不課稅收益）')"
        :message="$t(validation.firstError('allIncome'))"
      >
        <p class="control">
          <b-button>MOP</b-button>
        </p>
        <b-input v-model="allIncome"></b-input>
      </b-field>

      <b-field
        :label="$t('B.不屬課稅收益')"
        :message="$t(validation.firstError('freeTaxIncome'))"
      >
        <p class="control">
          <b-button>MOP</b-button>
        </p>
        <b-input v-model="freeTaxIncome"></b-input>
      </b-field>

      <table v-if="result" class="table is-fullwidth">
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <th class="is-half">
            {{ $t("C.固定扣除，相當於對B項扣減後之工作收益之25%") }}
          </th>
          <th>{{ formatNumber(fixedDelete) }}</th>
        </thead>
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <th class="is-half">
            {{ $t("D." + getInterval(interval) + "可課稅收益") }}
          </th>
          <th>{{ formatNumber(taxIncome) }}</th>
        </thead>
      </table>
      <div v-if="result" class="table-container">
        <table
          class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <thead class="has-text-centered">
            <tr>
              <th>{{ $t("由") }}</th>
              <th>{{ $t("至") }}</th>
              <th>{{ $t("稅率") }}</th>
              <th>{{ $t("可課稅收益") }}</th>
              <th>{{ $t("該級稅款") }}</th>
              <th>{{ $t("累計稅款") }}</th>
            </tr>
          </thead>
          <tbody class="has-text-centered">
            <tr v-for="(item, index) in result" :key="item.fromAmt">
              <td v-show="index != result.length - 1" class="has-text-right">
                {{
                  index == 0
                    ? formatNumber(item.getFromAmt())
                    : formatNumber(item.getFromAmt() + 0.01)
                }}
              </td>
              <td v-show="index != result.length - 1" class="has-text-right">
                {{ formatNumber(item.getToAmt()) }}
              </td>

              <td colspan="2" v-show="index == result.length - 1">
                {{ formatNumber(item.getFromAmt()) }}{{ $t("above") }}
              </td>
              <td class="has-text-right">
                {{ `${parseInt(item.taxRatio * 100)}%` }}
              </td>
              <td class="has-text-right">
                {{ formatNumber(item.getTaxIncome()) }}
              </td>
              <td class="has-text-right">
                {{ formatNumber(item.getTaxAmt()) }}
              </td>
              <td class="has-text-right">
                {{ item.getTaxIncome() ? addAccTax(item.getAccTax()) : "0.00" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table v-if="result" class="table is-fullwidth">
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <th class="is-half">
            {{ $t("根據法定稅率計出之" + getInterval(interval) + "稅款") }}
          </th>
          <th class="has-text-right">
            {{ "MOP " + formatNumber(takeWhole(getAllTax())) }}
          </th>
        </thead>
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <th class="is-half">
            {{ $t("根據有關年度財政預算案對職業稅稅額之30%扣減優惠") }}
          </th>
          <th class="has-text-right">
            {{ "MOP " + formatNumber(allFree) }}
          </th>
        </thead>
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <th class="is-half">
            {{ $t(getInterval(interval) + "應繳職業稅稅款") }}
          </th>
          <th class="has-text-right">
            {{ "MOP " + allTax }}
          </th>
        </thead>
        <thead class="table is-narrow is-fullwidth">
          <td rowspan="2" class="is-full">
            {{
              $t(
                "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。"
              )
            }}
          </td>
        </thead>
        <thead class="table is-narrow is-fullwidth">
          <td rowspan="2" class="is-full">
            {{ $t("(2)不足一元的部分，作一元計。") }}
          </td>
        </thead>
      </table>

      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: #00775e"
        >{{ $t("計算") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import numeral from "numeral";
// import Bignumber from "bignumber.js";

class TaxCalResult {
  /*
  income= the income
  fromAmt = the whole year amt
  toAmt = the whole year amt
  taxRatio = tax ratio
  period = period
  */
  constructor(income, fromAmt, toAmt, taxRatio, period, accTax) {
    this.fromAmt = fromAmt;
    this.toAmt = toAmt;
    this.taxRatio = taxRatio;
    this.income = income;
    this.period = period;
    this.accTax = accTax;
  }

  getPeriodParam() {
    switch (this.period) {
      case "month":
        return 12;
      case "quarter":
        return 4;
    }
    return 1;
  }
  getToAmt() {
    // console.log("至" + this.toAmt / this.getPeriodParam());
    return this.toAmt / this.getPeriodParam();
  }
  getFromAmt() {
    // console.log("由" + this.toAmt / this.getPeriodParam());
    return this.fromAmt / this.getPeriodParam();
  }

  getTaxIncome() {
    const delta = this.getToAmt() - this.getFromAmt();
    if (Math.min(this.income - this.getFromAmt(), delta) > 0) {
      return Math.min(this.income - this.getFromAmt(), delta);
    }
    return 0;
  }

  getTaxAmt() {
    const taxIncome = this.getTaxIncome();

    return taxIncome > 0 ? this.getTaxIncome() * this.taxRatio : 0;
  }

  getRemainNotCalAmt() {
    return this.income - this.getTaxIncome();
  }

  getAccTax() {
    return this.accTax + this.getTaxAmt();
  }
}

const Validator = SimpleVueValidation.Validator;
export default {
  name: "ProfessionalIncomeTax",
  props: [],
  data() {
    return {
      allIncome: "",
      freeTaxIncome: "",
      birthYear: "",
      ageType: "lessAge",
      interval: "month",
      intervalChoices: [
        { type: "month", optionName: "每月" },
        { type: "quarter", optionName: "季度" },
        { type: "year", optionName: "全年" },
      ],
      fixedDelete: 0,
      taxIncome: 0,
      result: null,
      allTypeTax: [],
    };
  },
  validators: {
    "birthYear,ageType": function (birthYear, ageType) {
      if (ageType == "equalAge") {
        return Validator.value(birthYear)
          .required()
          .custom(() => {
            const nowDate = new Date();
            if (birthYear.search("/") == -1) {
              return "simpleVueValidator_only_year";
            }
            if (nowDate.getFullYear() < birthYear.substring(0, 4)) {
              return "simpleVueValidator_only_year";
            }
          });
      }
    },

    allIncome: function (value) {
      return Validator.value(value).required().integer();
    },
    freeTaxIncome: function (value) {
      return Validator.value(value).required().integer();
    },
  },
  methods: {
    formatNumber(price) {
      return numeral(price).format("0,0.00");
    },
    getInterval(value) {
      const optionNa = this.intervalChoices.findIndex((n) => n.type == value);
      return this.intervalChoices[optionNa].optionName;
    },
    calculate() {
      if (this.result != null) {
        new TaxCalResult();
        this.allTypeTax = [];
      }
      this.$validate().then((success) => {
        if (success) {
          this.fixedDelete = (this.allIncome - this.freeTaxIncome) * 0.25;
          this.taxIncome =
            this.allIncome - this.freeTaxIncome - this.fixedDelete;

          let taxLevelBelow65 = [
            [0, 144000, 0],
            [144000, 164000, 0.07],
            [164000, 184000, 0.08],
            [184000, 224000, 0.09],
            [224000, 304000, 0.1],
            [304000, 424000, 0.11],
            [424000, 9999999999, 0.12],
          ];
          let taxLevelEqual65 = [
            [0, 179654.79, 0],
            [179654.79, 199654.79, 0.07],
            [199654.79, 219654.79, 0.08],
            [219654.79, 259654.79, 0.09],
            [259654.79, 339654.79, 0.1],
            [339654.79, 459654.79, 0.11],
            [459654.79, 9999999999, 0.12],
          ];
          let taxLevelAbove65 = [
            [0, 198000, 0],
            [198000, 218000, 0.07],
            [218000, 238000, 0.08],
            [238000, 278000, 0.09],
            [278000, 358000, 0.1],
            [358000, 478000, 0.11],
            [478000, 9999999999, 0.12],
          ];
          let taxLevel;
          if (this.ageType == "lessAge") {
            taxLevel = taxLevelBelow65;
          } else if (this.ageType == "equalAge") {
            taxLevel = taxLevelEqual65;
          } else {
            taxLevel = taxLevelAbove65;
          }
          console.log("年龄层" + this.ageType);
          let result = [];
          let accTax = 0;
          for (let i = 0; i < taxLevel.length; i++) {
            let taxCalResult = new TaxCalResult(
              this.taxIncome,
              taxLevel[i][0],
              taxLevel[i][1],
              taxLevel[i][2],
              this.interval,
              accTax
            );
            accTax = taxCalResult.getAccTax();
            result.push(taxCalResult);
          }
          result.forEach((x) => {
            this.allTypeTax.push(x.getAccTax());
          });
          this.result = result;
        }
      });
    },
    getAllTax() {
      return Math.max(...this.allTypeTax);
    },
    takeWhole(num) {
      return Math.trunc(num * 100) / 100;
    },
    addAccTax(num) {
      return this.formatNumber(Math.trunc(num * 100) / 100);
    },
  },
  computed: {
    allFree() {
      return this.takeWhole(this.takeWhole(this.getAllTax()) * 0.3);
    },
    allTax() {
      return this.formatNumber(Math.ceil(this.getAllTax() * 0.7));
    },
  },
};
</script>
